import { render, staticRenderFns } from "./labeled-samples-dossier.vue?vue&type=template&id=97886c54&"
import script from "./labeled-samples-dossier.ts?vue&type=script&lang=ts&"
export * from "./labeled-samples-dossier.ts?vue&type=script&lang=ts&"
import style0 from "../../shared/styles/statistical-analysis-dossier.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports